import { TRecentActivity } from "apis/dashboard/dashboard.interfaces";

export const recentActivityListMock: TRecentActivity[] = [
  {
    id: "1",
    type: "institute",
    description: "Institute created",
    timestamp: new Date().toISOString(),
  },
  {
    id: "2",
    type: "institute",
    description: "Institute updated",
    timestamp: new Date().toISOString(),
  },
  {
    id: "3",
    type: "institute",
    description: "Institute deleted",
    timestamp: new Date().toISOString(),
  },
  {
    id: "4",
    type: "institute",
    description: "Institute archived",
    timestamp: new Date().toISOString(),
  },
  {
    id: "5",
    type: "institute",
    description: "Institute unarchived",
    timestamp: new Date().toISOString(),
  },
  {
    id: "6",
    type: "institute",
    description: "Institute restored",
    timestamp: new Date().toISOString(),
  },
  {
    id: "7",
    type: "institute",
    description: "Institute deactivated",
    timestamp: new Date().toISOString(),
  },
  {
    id: "8",
    type: "institute",
    description: "Institute activated",
    timestamp: new Date().toISOString(),
  },
  {
    id: "9",
    type: "institute",
    description: "Institute suspended",
    timestamp: new Date().toISOString(),
  },
  {
    id: "10",
    type: "institute",
    description: "Institute resumed",
    timestamp: new Date().toISOString(),
  },
];
